/**
 * Basic functions
 */
/**
 * A function that does nothing
 *
 * This can be useful to pass as a parameter to functions that expect function parameters
 */
export function noop() { }
/**
 * An identity function (that returns itself)
 */
export function identity(value) {
    return value;
}
